import app from 'flarum/forum/app';
import Album from './models/Album';
import Picture from './models/Picture';

export function cimaiseAlbum(album: Album): string {
    const slug = album.slug();
    return app.route('cimaiseAlbumShow', {
        id: album.id() + (slug && slug.trim() ? '-' + slug : ''),
    });
}

export function cimaisePicture(picture: Picture): string {
    const album = picture.album();

    // At the moment this shouldn't happen because all pictures have an album
    // This is to please typescript
    if (!album) {
        return '';
    }

    const slug = album.slug();

    return app.route('cimaisePictureShow', {
        album: album.id() + (slug && slug.trim() ? '-' + slug : ''),
        id: picture.id(),
    });
}
